<template>
    <div >

       <header-block @userLogout="logout" :token="token" :user="user" :uid="uid" :platform="platform" :cart="cart" :order="order" :isMobile="isMobile" :hasShop="hasShop" :cartMarkets="cartMarkets" @getCart="getCart"></header-block>

       <div v-if="platform && (platform.type == 'payment' || platform.type == 'oplata')" class="d-flex container">
          <div class="main_content" >
              <transition name="pagefade">
                <router-view :profile="user" :uid="uid" :carts="cart" @getCart="getCart" :platform="platform" :isMobile="isMobile"/>
              </transition>
            </div>
       </div>
        <div v-else class="d-flex container">
            <div class="left_menu" v-if="platform.id != 34241 && platform.id != 34242 && platform.id != 34243 && platform.id != 34246 && platform.id != 34247 && platform.id != 34248">
              
              <leftmenu_baby v-if="platform.type == 'babygum' || platform.type == 'health'" :uid="uid" :profile="user" :openMarketplace="openMarketplace" :platform="platform"/>
               <Leftmenu_wedding v-else-if="platform.type == 'wedding' || platform.type == 'birthday' || platform.type == 'babyparty' || platform.type == 'photo' || platform.type == 'newyear'" :uid="uid" :profile="user" :openMarketplace="openMarketplace" :platform="platform"/>
               <Leftmenu_kinder v-else-if="platform.type == 'kinder'" :uid="uid" :profile="user" :openMarketplace="openMarketplace" :platform="platform"/>
              <Leftmenu_trc v-else-if="platform.type == 'trc'" :uid="uid" :profile="user" :openMarketplace="openMarketplace" :platform="platform"/>
              <Leftmenu_index v-else-if="platform.type == 1" :uid="uid" :profile="user" :openMarketplace="openMarketplace" :platform="platform"/>
               <leftmenu v-else :uid="uid" :profile="user" :openMarketplace="openMarketplace" :platform="platform"/>

            </div>

            
            <div  class="main_content">
              <transition name="pagefade">
                <router-view :profile="user" :uid="uid" :carts="cart" @getCart="getCart" :platform="platform" :isMobile="isMobile"/>
              </transition>
            </div>

        </div>
<div v-if="showEmailModal" class="email_modal-overlay">
      <div class="email_modal">
        <h2>Привяжите настоящую почту</h2>
        <p>
          Для восстановления пароля необходимо указать реальный адрес электронной почты.
        </p>
        <button @click="goToEditEmail()">Перейти</button>
      </div>
</div>

    </div>
</template>

<script>
import HeaderBlock from './layouts/HeaderBlock.vue';
import Leftmenu from './layouts/Leftmenu.vue';
import Leftmenu_baby from './layouts/Leftmenu_baby.vue';
import Leftmenu_kinder from './layouts/Leftmenu_kinder.vue';
import Leftmenu_wedding from './layouts/Leftmenu_wedding.vue';
import Leftmenu_trc from './layouts/Leftmenu_trc.vue'
import Leftmenu_index from './layouts/Leftmenu_index.vue'
export default {
  name: 'index',
  data: () => ({
    showEmailModal: false,
      token: '',
      user: '',
      uid: 0,
       platform: {},
       cart: [],
       cartMarkets: [],
       openMarketplace: '0',
       hasShop: null,
       order: null,
       isMobile: false,
       cartLoad: false,
       loadUserDate: false,
  }),
  created() {
    this.initUtmId();
  },
    mounted() {
      this.checkMobile()
      this.getToken()
      this.getPlatform()
    },
    updated(){
      this.getToken()
    },
    watch: {
    'uid' (newVal, oldVal) {
      if(newVal > 0 && newVal != oldVal){
    this.listenNotiMessages()
    //this.checkemail()
  }
    }
  },
    
    methods: {
getUrlParameter(name) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    },
    saveUtmId(utmId) {
      if (utmId) {
        localStorage.setItem('utm_id', utmId);
      }
    },
    initUtmId() {
      const utmIdFromUrl = this.getUrlParameter('utm_id');
      if (utmIdFromUrl) {
        this.saveUtmId(utmIdFromUrl);
      }
    },

      goToEditEmail() {
        this.showEmailModal = false;
      this.$router.push('/edit')
    },
      checkemail(){
        if (this.uid > 0) {
          var n_email = this.user.email.split('@')[1];
          var с_email = n_email.split('.');
           if (с_email[0] == 'lenteres' || с_email[1] == 'lenteres') {
             this.showEmailModal = true
           }
          }
      },
      logout(){
        this.uid = 0
        this.user = ''
        //this.$router.push('/edit')
        window.location.href = '/';
      },
      listenNotiMessages() {
        if(!window.Echo){
          return;
        }
      console.log('uid: '+this.uid)
      Echo.private(`message.noti.`+this.uid)
    .listen('.message.noti', (e) => {
      //this.getUserData()
      
    });

    },
      checkMobile(){
        this.openMarketplace = openMarketplace
    const main_screenWidth = window.screen.width
    if(main_screenWidth <= 720){
      this.isMobile = true
    }
  },
      getCart(load = true, update = 0){
        if(this.cartLoad && update == 0){
          return
        }
        if(load && this.user == ''){
          return
        }
        this.cartLoad = true
          axios.post('/api/cart.get').then( res => {
            this.cart = res.data.carts;
            this.order = res.data.order;
            this.cartMarkets = res.data.markets;
            this.hasShop = res.data.shop;
            this.cartLoad = false
          }).catch( error => {
            //localStorage.removeItem('x_xsrf_token')
          })
        },
      getPlatform(){
      axios.post('/api/platform.get').then(response => {
         this.platform = response.data;
         if(this.platform.id == 34230 || this.platform.id == 34231 || this.platform.id == 34232 || this.platform.id == 34236 || this.platform.id == 34235){
          const xsrfToken = document.cookie.split('; ')
    .find(row => row.startsWith('XSRF-TOKEN='));

  if (xsrfToken) {
    const tokenValue = xsrfToken.split('=')[1]; 
    localStorage.setItem('x_xsrf_token', tokenValue);
  }
         }
            this.closePreloader()
        })
    },
      closePreloader(){
        return document.querySelector(".preloader").remove();       
      },
      getUserData(){
        
        if(this.uid != 0 || this.loadUserDate){
          return
        }
        this.loadUserDate = true
        axios.post('/api/user').then( res => {
            this.user = res.data;
            this.uid = this.user.id;
            if(platform_type == 'shop' || platform_type == 'market'){
              this.getCart(false)
            }
            if((this.platform.id == 34230 || this.platform.id == 34231 || this.platform.id == 34232 || this.platform.id == 34236 || this.platform.id == 34235) && !window.Echo){
          window.Pusher = require('pusher-js');
      window.Echo = new Echo({
        broadcaster: 'pusher',
        key: '21rewfr43',
        cluster: 'mt1',
        forceTLS: true,
        encrypted: true,
        // auth: {
        //   withCredentials: true,
        //    headers: {
        //      'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        //    },
        // },
        wsHost: 'lenteres.ru',
        wsPort: 3030,
        wssPort: 3030,
      });
      this.listenNotiMessages();
            }
            this.loadUserDate = false
            initSW();
        }).catch( error => {
          this.loadUserDate = false
          //localStorage.removeItem('x_xsrf_token')
        })
      },
      getToken(){
         this.token = localStorage.getItem('x_xsrf_token')
         if(!this.token && this.user != ''){
          this.user = ''
         }
         if(this.user == '' && this.token){
          this.getUserData()
         }

      }
    }, 
    components: {
      HeaderBlock, Leftmenu, Leftmenu_baby, Leftmenu_wedding, Leftmenu_kinder, Leftmenu_trc, Leftmenu_index
    }
}
</script>

<style scoped>
 .email_modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(166, 187, 221, 0.25);
  backdrop-filter: blur(12px);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.4s ease;
      z-index: 9999;
}

.email_modal {
  background: #fff;
  border-radius: 20px;
  padding: 40px 32px;
  max-width: 440px;
  width: 90%;
  box-shadow: 0 12px 40px rgba(0,0,0,0.12);
  text-align: center;
  transform: scale(0.95);
  animation: popIn 0.35s ease forwards;
}

/* заголовок */
.email_modal h2 {
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 16px;
  background: linear-gradient(90deg, #a6bbdd, #8fa6c7);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* текст */
.email_modal p {
  font-size: 1rem;
  line-height: 1.6;
  color: #444;
  margin-bottom: 28px;
}

/* кнопка */
.email_modal button {
  background: #a6bbdd;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 14px 28px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 16px rgba(166, 187, 221, 0.4);
}

.email_modal button:hover {
  background: #8fa6c7;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(166, 187, 221, 0.5);
}

/* анимации */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes popIn {
  to { transform: scale(1); }
}
</style>
